export default __webpack_public_path__ + "static/media/CNo.55-1.c18502cd.jpg";